// extracted by mini-css-extract-plugin
export default {"logo-mark":"Y_Qs","logo-mark-bounce":"Y_Qt","bounce":"Y_Qv"};